import { render, staticRenderFns } from "./PartsDesignerLayout.vue?vue&type=template&id=70d97094"
import script from "./PartsDesignerLayout.vue?vue&type=script&lang=ts"
export * from "./PartsDesignerLayout.vue?vue&type=script&lang=ts"
import style0 from "./PartsDesignerLayout.vue?vue&type=style&index=0&id=70d97094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports